export const MANDATORY_STATUSES = ['ONG', 'COM']

export const INITIAL_PARAMS = {
  status: [],
  region: [],
  country: [],
  cluster: [],
}

export const INITIAL_PARAMS_MLFS = {
  status: [],
  agency: [],
  region: [],
  country: [],
  cluster: [],
}
